import { Outlet } from 'react-router-dom';

function Preautorizar() {
  return <Outlet />;
}

export default Preautorizar;
